<script setup>
import { estimationRate } from '@/utils/index'
import { useUserStore } from '@/stores/userStore'

const userStore = useUserStore()
const param = reactive({
    classifyAll: [
        {
            "id": "1621463515779121154",
            "name": "\u670d\u9970",
            "children": [
                {
                    "id": "1622303455412785154",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1",
                    "send": true
                },
                {
                    "id": "1622303455429562369",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622303455442145282",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622303455450533889",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622303455467311105",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621463579591262210",
            "name": "\u978b\u5b50",
            "children": [
                {
                    "id": "1622303513952686081",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622795934289895426",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622303548073349122",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622303513965268994",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622303513977851905",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621463636352778242",
            "name": "\u9970\u54c1",
            "children": [
                {
                    "id": "1622914696109187073",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622914696138547202",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622914696151130113",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622914696159518721",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622914696172101633",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621463715411214337",
            "name": "\u624b\u8868",
            "children": [
                {
                    "id": "1622914829496442882",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622914829483859969",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622914829509025794",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622914829517414402",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622914829525803010",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1622914829534191618",
                    "name": "\u914d\u5957\u7535\u6c60",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621463780972380161",
            "name": "\u773c\u955c",
            "children": [
                {
                    "id": "1622914989681106946",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622914989693689858",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622914989702078465",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622914989710467074",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621463878452199426",
            "name": "\u7bb1\u5305",
            "children": [
                {
                    "id": "1622915044123172865",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622915044135755778",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915044148338689",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915044156727298",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621463966322868225",
            "name": "\u76ae\u5e26",
            "children": [
                {
                    "id": "1622915145591775234",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622915145600163842",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915145612746753",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915145621135361",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621464055351164929",
            "name": "\u98df\u54c1",
            "children": [
                {
                    "id": "1622915257097347074",
                    "name": "\u6db2\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622915257088958466",
                    "name": "\u975e\u8089\u7c7b\u98df\u54c1",
                    "remark": ""
                },
                {
                    "id": "1622915257076375553",
                    "name": "\u8089\u7c7b\u98df\u54c1",
                    "remark": ""
                },
                {
                    "id": "1622915257105735682",
                    "name": "\u818f\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622915257114124290",
                    "name": "\u7c89\u672b",
                    "remark": ""
                },
                {
                    "id": "1622915257122512897",
                    "name": "\u6613\u71c3\u54c1",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621464115119996930",
            "name": "\u836f\u54c1",
            "children": [
                {
                    "id": "1622915441906769922",
                    "name": "\u6db2\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622915441915158529",
                    "name": "\u818f\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622915441927741441",
                    "name": "\u7c89\u672b",
                    "remark": ""
                },
                {
                    "id": "1622915441944518657",
                    "name": "\u6613\u71c3\u54c1",
                    "remark": ""
                },
                {
                    "id": "1622915441936130050",
                    "name": "\u8349\u836f",
                    "remark": ""
                },
                {
                    "id": "1622915441952907266",
                    "name": "\u5176\u5b83",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621464191296946178",
            "name": "\u5316\u5986\u54c1",
            "children": [
                {
                    "id": "1671190909479919617",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1",
                    "send": true
                },
                {
                    "id": "1622915685595832322",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915685604220930",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915685612609537",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915685658746881",
                    "name": "\u818f\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622915685667135489",
                    "name": "\u7c89\u672b",
                    "remark": ""
                },
                {
                    "id": "1622915685675524097",
                    "name": "\u5176\u5b83",
                    "remark": ""
                },
                {
                    "id": "1622915685629386754",
                    "name": "100ML\u53ca\u4ee5\u4e0b\u6db2\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622915685637775362",
                    "name": "100ML\u4ee5\u4e0a\u6db2\u4f53",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622915685641969665",
                    "name": "\u9999\u6c34&\u6db2\u4f53\u9999\u85b0\uff08100ML\u53ca\u4ee5\u4e0b\uff09",
                    "remark": "",
                    "send": true
                }
            ]
        },
        {
            "id": "1621464262407176193",
            "name": "\u7535\u5b50\u4ea7\u54c1",
            "children": [
                {
                    "id": "1622915853330243585",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622915853338632193",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915853347020801",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915853355409409",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622915853363798018",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1752897434603819010",
                    "name": "\u5e26\u78c1\u6027",
                    "remark": "ProductFeatureDO:remark:1752897057510723586"
                },
                {
                    "id": "1622915853372186625",
                    "name": "\u914d\u5957\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1721908398401863681",
                    "name": "\u624b\u673a",
                    "remark": "ProductFeatureDO:remark:1721908231640526849"
                },
                {
                    "id": "1828458105386643457",
                    "name": "\u6e38\u620f\u673a",
                    "remark": "ProductFeatureDO:remark:1828457988575289346",
                    "send": true
                }
            ]
        },
        {
            "id": "1621464598672916482",
            "name": "\u65e5\u7528\u54c1",
            "children": [
                {
                    "id": "1622300905934458881",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1622300905951236098",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622301915583123458",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622916406995148802",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622301915595706369",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1752897474084798467",
                    "name": "\u5e26\u78c1\u6027",
                    "remark": "ProductFeatureDO:remark:1752897057510723586"
                },
                {
                    "id": "1622301915629260802",
                    "name": "\u914d\u5957\u7535\u6c60",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622916407016120322",
                    "name": "\u818f\u4f53",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622916407028703234",
                    "name": "\u7c89\u672b",
                    "remark": ""
                },
                {
                    "id": "1622916407037091842",
                    "name": "\u6613\u71c3\u54c1",
                    "remark": ""
                },
                {
                    "id": "1671191105077092354",
                    "name": "100ML\u53ca\u4ee5\u4e0b\u6db2\u4f53",
                    "remark": ""
                },
                {
                    "id": "1671191105068703745",
                    "name": "100ML\u4ee5\u4e0a\u6db2\u4f53",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621464371329056770",
            "name": "\u6210\u4eba\u7528\u54c1",
            "children": [
                {
                    "id": "1622915973069234177",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1752897534533111810",
                    "name": "\u5e26\u78c1\u6027",
                    "remark": "ProductFeatureDO:remark:1752897057510723586"
                },
                {
                    "id": "1622915973077622785",
                    "name": "\u914d\u5957\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1622915973094400001",
                    "name": "\u5176\u5b83",
                    "remark": ""
                },
                {
                    "id": "1671191044700086274",
                    "name": "100ML\u53ca\u4ee5\u4e0b\u6db2\u4f53",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1671191044708474882",
                    "name": "100ML\u4ee5\u4e0a\u6db2\u4f53",
                    "remark": ""
                }
            ]
        },
        {
            "id": "1621464434822430722",
            "name": "\u7eaf\u7535\u6c60",
            "children": [
                {
                    "id": "1622923399256432642",
                    "name": "\u7535\u6c60",
                    "remark": "",
                    "send": true
                }
            ]
        },
        {
            "id": "1621464502388473858",
            "children": [
                {
                    "id": "1622301739942449153",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                }
            ]
        },
        {
            "id": "1621464668554215425",
            "name": "\u73a9\u5177\u6e38\u620f",
            "children": [
                {
                    "id": "1621805542559485953",
                    "name": "\u666e\u8d27",
                    "remark": "\u4e0d\u542b\u54c1\u724c\u3001\u7535\\u78c1\u3001\u6db2\u4f53\u3001\u7c89\u672b\u3001\u818f\u4f53\u3001\u6613\u71c3\u6613\u7206\u7b49\u654f\u611f\u6027\u8d28\u7684\u5546\u54c1"
                },
                {
                    "id": "1621805729344425985",
                    "name": "\u666e\u901a\u54c1\u724c",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622300874003222530",
                    "name": "\u56fd\u9645\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622916676105887745",
                    "name": "\u5962\u4f88\u54c1\u724c",
                    "remark": ""
                },
                {
                    "id": "1622916676118470657",
                    "name": "\u5185\u7f6e\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1752897559048814594",
                    "name": "\u5e26\u78c1\u6027",
                    "remark": "ProductFeatureDO:remark:1752897057510723586"
                },
                {
                    "id": "1622916676126859265",
                    "name": "\u6db2\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622916676135247874",
                    "name": "\u914d\u5957\u7535\u6c60",
                    "remark": ""
                },
                {
                    "id": "1622916676143636482",
                    "name": "\u818f\u4f53",
                    "remark": ""
                },
                {
                    "id": "1622916676152025090",
                    "name": "\u7c89\u672b",
                    "remark": ""
                },
                {
                    "id": "1622916676160413697",
                    "name": "\u6613\u71c3\u54c1",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622916676063944706",
                    "name": "\u9ad8\u5ea630CM\u4ee5\u4e0b\u624b\u529e",
                    "remark": "",
                    "send": true
                },
                {
                    "id": "1622916676063944707",
                    "name": "\u9ad8\u5ea630CM\u4ee5\u4e0a\u624b\u529e",
                    "remark": "",
                    "send": true
                }
            ]
        }
    ],
})
const item = ref();
const showType = ref(false);

//获取国家信息
const getCountry = () => {

}
const handleChange = () => {
}
//获取分类信息
const getClassify = () => {

}


const selctOne = (i) => {

}
const changeSaerch = (str) => {

}
//计算运费
const handleQuery = () => {

}
const isMobile = ref(false);
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    item.value=JSON.parse(localStorage.getItem('estimationOne'));
    console.log(item.value)
    // getCountry();
    // getClassify();
})
</script>
<template>
    <div class="estimation">
        <div class="pcEstimation" v-if="isMobile == false">
            <div class="title">{{$t('setup564')}}</div>
            <div class="table">
                <div class="line flex">
                    <div class="flex40">{{$t('setup565')}}{{item?.restrictions?.minWeight||0}}g</div>
                    <div class="flex40">{{$t('setup566')}}{{item?.restrictions?.maxWeight||0}}g</div>
                </div>
                <div class="line">{{$t('setup568')}} {{item?.restrictions?.dimensionRestriction}}</div>
                <div class="line lh24">{{$t('setup567')}} {{item?.restrictions?.volumeWeightRule}}</div>
                <div class="line border-none">
                    <div class="flex">
                        <div class="tag flex">
                            <div class="nosend-icon"></div>
                            <div>{{$t('setup569')}}</div>
                        </div>
                        <div class="tag flex">
                            <div class="send-icon"></div>
                            <div>{{$t('setup570')}}</div>
                        </div>

                    </div>
                    <div v-for="i in item?.restrictions?.categoryRestrictions">
                        <div class="type-title">{{ i.name }}:</div>
                        <div class="flex">
                            <div v-for="name in i.allowList" class="type-item" >{{
                                name }}</div>
                                  <div v-for="name in i.blockList" class="type-item nosend">{{
                                name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sub-title">{{$t('setup571')}}</div>
            <div class="table" style="border-bottom: none;border-right: none;">
                <div class="flex">
                    <div class="unit-item flex5">{{$t('setup572')}}</div>
                    <div class="unit-item flex5">{{$t('setup573')}}</div>
                    <div class="unit-item flex5">{{$t('setup574')}}</div>
                    <div class="unit-item flex5">{{$t('setup575')}}</div>
                    <div class="unit-item flex5">{{$t('setup576')}}</div>
                </div>
                <div class="flex">
                    <div class="unit-item flex5 blod">
                        {{ estimationRate(item?.feeDetail?.feeFirst||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                       /{{item?.feeDetail?.weightFirst||1}}g</div>
                    <div class="unit-item flex5 blod">
                        {{ estimationRate(item?.feeDetail?.feeContinue||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                        /{{item?.feeDetail?.weightContinue||1}}g</div>
                    <div class="unit-item flex5 blod">
                        {{ estimationRate(item?.feeDetail?.customsFee||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                    </div>
                    <div class="unit-item flex5 blod">
                        {{ estimationRate(item?.feeDetail?.fuelFee||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                    </div>
                    <div class="unit-item flex5 blod">
                        {{ estimationRate(item?.feeDetail?.operationFee||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                    </div>
                </div>
            </div>
            <div class="sub-title">{{$t('setup571')}}</div>
            <div class="bottom-text">{{item?.features}}
            </div>
        </div>
        <div class="phoneEstimation" v-else>
            <div class="table">
                <div class="line flex">

                    <div class="flex50">
                        <div>{{$t('setup565')}} </div>
                        <div class="font">{{item?.restrictions?.minWeight||0}}g</div>
                    </div>
                    <div class="flex50">
                        <div>{{$t('setup566')}}</div>
                        <div class="font">{{item?.restrictions?.maxWeight||0}}g</div>
                    </div>
                </div>
                <div>
                    <div>{{$t('setup568')}}</div>
                    <div class="font">{{item?.restrictions?.dimensionRestriction}}</div>
                </div>
                <div>{{$t('setup567')}}</div>
                <div style=" margin: 12px 0 26px;">
                    {{item?.restrictions?.volumeWeightRule}}</div>
                <div class="line border-none">
                    <div class="flex">
                        <div class="tag flex">
                            <div class="nosend-icon"></div>
                            <div>{{$t('setup569')}}</div>
                        </div>
                        <div class="tag flex">
                            <div class="send-icon"></div>
                            <div>{{$t('setup570')}}</div>
                        </div>

                    </div>
                    <div v-for="i in item?.restrictions?.categoryRestrictions">
                        <div class="type-title">{{ i.name }}:</div>
                        <div class="flex">
                            <div v-for="name in i.allowList" class="type-item">{{
                                name }}</div>
                                <div v-for="name in i.blockList" class="type-item nosend">{{
                                name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sub-title">{{$t('setup571')}}</div>
            <div class="table1">
                <div>
                    <div>{{$t('setup572')}}</div>
                    <div> {{ estimationRate(item?.feeDetail?.feeFirst||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                        /{{item?.feeDetail?.weightFirst||1}}g</div>
                </div>
                <div>
                    <div>{{$t('setup573')}}</div>
                    <div>  {{ estimationRate(item?.feeDetail?.feeContinue||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                        /{{item?.feeDetail?.weightContinue||1}}g</div>
                </div>
                <div>
                    <div>{{$t('setup574')}}</div>
                    <div>                        {{ estimationRate(item?.feeDetail?.customsFee||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                    </div>
                </div>
                <div>
                    <div>{{$t('setup575')}}</div>
                    <div>                        {{ estimationRate(item?.feeDetail?.fuelFee||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                    </div>
                </div>
                <div>
                    <div>{{$t('setup576')}}</div>
                    <div>                        {{ estimationRate(item?.feeDetail?.operationFee||0, userStore.exchangeRate.symbol,userStore.exchangeRate.rate)}}
                    </div>
                </div>
            </div>
            <div class="sub-title">{{$t('setup571')}}</div>
            <div class="bottom-text">{{item?.features}}
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
:deep(.el-input__inner) {
    text-align: end;
}

:deep(.el-select__placeholder) {
    text-align: end;
}

:deep(.el-cascader__tags) {
    left: 130px;
}

.estimation {
    // min-height: 100vh;
    background-color: #eef0f1;

    .pcEstimation,
    .phoneEstimation {
        width: 1200px;
        margin: 20px auto;
        padding: 30px 30px 30px 20px;
        background: #fff;
        border-radius: 8px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        line-height: 14px;
        text-align: left;
        font-style: normal;

        .title,
        .sub-title {
            font-weight: bold;
            font-size: 18px;
            color: #11192D;
            line-height: 24px;
        }

        .sub-title {
            font-weight: normal;
            font-size: 16px;
            padding: 30px 0 0 10px;
        }

        .table {
            margin: 30px 0 0 10px;
            border: 1px solid #E5E8EC;

            .line {
                // height: 56px;

                border-bottom: 1px solid #E5E8EC;
                padding: 20px;

                .type-title {
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                    margin-top: 25px;
                }

                .type-item {
                    padding: 0 15px;
                    height: 30px;
                    line-height: 30px;
                    background: #F6FCF6;
                    border-radius: 4px;
                    border: 1px solid #29CC39;
                    margin-top: 12px;
                    margin-right: 12px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #29CC39;
                }

                .nosend {
                    border: 1px solid #FC3938;
                    background: #FEF6F5;
                    color: #FC3938;
                }
            }

            .unit-item {
                padding: 10px;
                font-size: 14px;
                color: #888888;
                line-height: 14px;
                font-weight: normal;
                border-bottom: 1px solid #E5E8EC;
                border-right: 1px solid #E5E8EC;
            }

            .blod {
                font-weight: bold;
                color: #333;
            }

            .border-none {
                border: none;
            }

            .lh24 {
                line-height: 24px;
            }

            .flex {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .flex40 {
                    width: 40%;
                }

                .flex5 {
                    width: 20%;
                }

                .tag {
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                    margin-right: 30px;

                    .nosend-icon,
                    .send-icon {
                        width: 12px;
                        height: 12px;
                        margin-right: 12px;
                        border-radius: 50%;
                        background: #FC3938;
                    }

                    .send-icon {
                        background: #29CC39;
                    }
                }
            }
        }

        .bottom-text {
            padding: 20px 0 0 10px;
            font-size: 14px;
            color: #666666;
            line-height: 28px;
            font-weight: 400;
        }

    }

    .phoneEstimation {
        width: 100%;
        padding: 0;
        margin: 0;
        font-weight: normal;
        color: #888;

        .sub-title {
            padding: 20px 0 0 0;
        }

        .table,
        .table1 {
            margin: 0;
            padding: 0;
            border: none;

            .line {
                // height: 56px;

                border: none;
                padding: 0;

                .type-title {
                    font-size: 14px;
                    margin-top: 25px;
                    margin-bottom: 5px;
                }

                .type-item {
                    padding: 0 10px;
                    height: 26px;
                    line-height: 26px;
                    margin-top: 6px;
                    margin-right: 6px;
                }

                .nosend {
                    border: 1px solid #FC3938;
                    background: #FEF6F5;
                    color: #FC3938;
                }
            }

            .unit-item {
                padding: 10px;
                font-size: 14px;
                color: #888888;
                line-height: 14px;
                font-weight: normal;
                border-bottom: 1px solid #E5E8EC;
                border-right: 1px solid #E5E8EC;
            }

            .blod {
                font-weight: bold;
                color: #333;
            }

            .border-none {
                border: none;
            }

            .lh24 {
                line-height: 24px;
            }

            .flex {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .flex50 {
                    width: 50%;

                    
                }

                .flex5 {
                    width: 20%;
                }

                .tag {
                    color: #888;
                }
            }
            .font {
                font-weight: bold;
                color: #333333;
                margin: 12px 0 26px;
            }
        }

        .table1 {
            margin-top: 10px;
            border-top: 1px solid #E5E8EC;
            border-left: 1px solid #E5E8EC;

            >div {
                display: flex;

                >div {
                    width: 50%;
                    padding: 10px 15px;
                    border-bottom: 1px solid #E5E8EC;
                    border-right: 1px solid #E5E8EC;
                }

                >div:last-child {
                        font-weight: bold;
                        color: #333333;
                        // margin: 12px 0 26px;
                }
            }
        }

        .bottom-text {
            padding: 10px 0 0 0;
        }

       

    }
}
</style>